import AXIOS from '@/axios-instance';

export default {

  addClient(client) {
    return AXIOS.post("/client", client);
  },
  retrieveClients(){
    return AXIOS.get("/client");
  },
  getClientColor(){
    return AXIOS.get("/client/color");
  },
  getClientIcon(){
    return AXIOS.get("/client/icon");
  },
  changeClientActiveState(state){
    return AXIOS.post("/client/state", state);
  },
  changeExternalWFMSIntegration(integration){
    return AXIOS.post("/client/integration", integration);
  },
  /* changeExternalWFMSUrl(url){
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/client/integration/url", url, config);
  },
  changeExternalWFMSUrl(url){
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/client/integration/url", url, config);
  } */
  getIntegrationState(){
    return AXIOS.get("/client/integration/state");
  },
  getIntegrationData(){
    return AXIOS.get("/client/integration");
  }
}